export const STARSCORING = [
  { label: 'Situation (S)', value: 20 },
  { label: 'Task (T)', value: 10 },
  { label: 'Action (A)', value: 60 },
  { label: 'Result (R)', value: 10 },

];
